import { useEffect, useState } from 'react';

import { Sizes } from '@types-internal';

// In Modernize Payment, mobile device size is determined by width <= 544px,
// so the default size is set to Sizes.SM.

export default function useIsMobile(size: Sizes = Sizes.SM) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= size);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth <= size);
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isMobile;
}
